import React, { Component, Fragment } from 'react';
import { withRouter, NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  Dropdown,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import SvgRender from 'components/helpers/SvgRender';

import { getAuthenticated } from 'views/auth/_reducers';
import { getAccount } from 'views/account/_selectors';

import avatar from 'assets/svg/default_avatar.svg';
import logo from 'assets/svg/Logo.svg';
import facebook from 'assets/svg/social/facebook.svg';
import twitter from 'assets/svg/social/twitter.svg';
// import linkedIn from 'assets/svg/social/linkedIn.svg';
import logout from 'assets/svg/logout.svg';
import profile from 'assets/svg/profile.svg';
import dashboard from 'assets/svg/dashboard.svg';
import noTextLogo from 'assets/svg/notext_logo.svg';

class Header extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
      isDropdownOpen: false
    };

    this.toggle = this.toggle.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState(prevState => ({
      isDropdownOpen: !prevState.isDropdownOpen
    }));
  }

  toggle() {
    if (!this.state.isOpen) {
      document.querySelector('html').classList.add('prevent-scroll');
    } else {
      document.querySelector('html').classList.remove('prevent-scroll');
    }

    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentWillUnmount() {
    document.querySelector('html').classList.remove('prevent-scroll');
  }

  renderLogoOnly = () => {
    return (
      <div className="header">
        <Navbar className="justify-content-center">
          <SvgRender path={logo} svgClassName="logo-height" />
        </Navbar>
      </div>
    );
  };

  renderPrivateMenu = () => {
    return (
      <Fragment>
        {this.props.location.pathname != '/' ? (
          <NavLink activeClassName="public-active" to="/" className="dropdown-item d-flex reverse">
            <SvgRender
              path={noTextLogo}
              style={{ height: 15 }}
              svgClassName="white-svg"
              className="mr-1"
            />
            Public site
          </NavLink>
        ) : (
          <NavLink to="/channels" tag="li" className="dropdown-item d-flex reverse first">
            <SvgRender path={dashboard} svgClassName="white-svg" className="mr-1" />
            <span>Go to Dashboard</span>
          </NavLink>
        )}
        <NavLink to="/profile" className="dropdown-item d-flex reverse">
          <SvgRender path={profile} svgClassName="white-svg" className="mr-1" />
          <span>Profile</span>
        </NavLink>
        <div className="dropdown-divider d-none d-lg-block" />
        <NavLink to="/logout" className="dropdown-item d-flex reverse last">
          <SvgRender path={logout} svgClassName="white-svg" className="mr-1" />
          <span>Logout</span>
        </NavLink>
      </Fragment>
    );
  };

  render() {
    const { account } = this.props;

    return (
      <div className="header">
        <Navbar expand="lg">
          <NavLink to={'/'} className="navbar-brand pl-lg-8">
            <SvgRender path={logo} svgClassName="logo-height" />
          </NavLink>

          <NavbarToggler
            id="menu-toggle"
            className={'hamburger hamburger--squeeze btn' + (this.state.isOpen ? ' open' : '')}
            onClick={e => this.toggle()}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </NavbarToggler>
          <Collapse
            id="navbarMenu"
            isOpen={this.state.isOpen}
            className="justify-content-end navbar-menu"
            navbar
          >
            <Nav className="navbar-header-nav">
              <NavItem className={'split' + this.props.location.pathname !== '/' ? ' d-none' : ''}>
                <a href="http://docs.apparatusapp.com/" className="reverse">
                  For Developers
                </a>
              </NavItem>
              {!this.props.authenticated ? (
                <NavItem>
                  <Link to="/login" className="no-line reverse btn withBorder">
                    Log In
                  </Link>
                </NavItem>
              ) : (
                <Fragment>
                  <NavItem className="drop-container d-none d-lg-flex">
                    <div
                      className={`nav-avatar img-circle d-flex ${!account.photo ? 'default' : ''}`}
                      style={{
                        backgroundImage: `url(${account.photo ? account.photo : avatar})`
                      }}
                    />
                    <Dropdown isOpen={this.state.isDropdownOpen} toggle={this.toggleDropdown}>
                      <DropdownToggle caret className="border-0 drop-title px-2">
                        {!account ? 'Sample user name' : account.name}
                      </DropdownToggle>
                      <DropdownMenu right tag="div">
                        {this.renderPrivateMenu()}
                      </DropdownMenu>
                    </Dropdown>
                  </NavItem>
                  <NavItem className="d-flex d-lg-none flex-column">
                    {this.renderPrivateMenu()}
                  </NavItem>
                </Fragment>
              )}
            </Nav>
            <div className="menu-footer w-100 align-items-center justify-content-between px-5 d-flex d-lg-none">
              <Link to="/legal/privacy-policy" className="legal d-block d-lg-none mb-0">
                Legal Documents
              </Link>
              <div className="social-wrap d-flex d-lg-none align-items-center">
                <a href="https://www.facebook.com/apparatusapp" target="_blank">
                  <SvgRender style={{ height: 16 }} path={facebook} svgClassName="white-svg" />
                </a>
                <a
                  href="https://www.twitter.com/Apparatus_app"
                  className="ml-2 mr-2"
                  target="_blank"
                >
                  <SvgRender style={{ height: 16 }} path={twitter} svgClassName="white-svg" />
                </a>
                {/*
                <a href="#" target="_blank">
                  <SvgRender style={{ height: 16 }} path={linkedIn} svgClassName="white-svg" />
                </a>
               */}
              </div>
            </div>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticated: getAuthenticated(state),
    account: getAccount(state)
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(Header)
);



// WEBPACK FOOTER //
// ./src/components/layouts/Header.js